import { api } from "@state/apiSlice";

const stageRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    updateStage: build.mutation<{ message: string }, { boardId: number; itemId: number }>({
      query: ({ boardId, itemId }) => ({
        url: `/init/${boardId}/${itemId}/update`,
        headers: {
          "Content-Type": "application/json",
        },
        method: "PATCH",
      }),
    }),
  }),
});

export default stageRequestsSlice;
